import {
    getApplicationAccount,
    listApplicationAccounts
} from './queries';
import {
    createApplicationAccount,
    deleteApplicationAccount,
    updateApplicationAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {ApplicationAccount} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListApplicationAccounts = {
    listAccountApplications: { items: ApplicationAccount[], nextToken?: string | null }
}

export type GetApplicationAccount = {
    getAccountApplication: ApplicationAccount
}

export type CreateApplicationAccount = {
    createAccountApplication: ApplicationAccount
}

export type UpdateApplicationAccount = {
    updateAccountApplication: ApplicationAccount
}

export type DeleteApplicationAccount = {
    deleteAccountApplication: string
}

const client = generateClient();


// AccountApplicationsFilterInput declares exactly these three fields. AppSync
// rejects the whole request if the variable carries a key the Input does not
// declare, so the filter is whitelisted rather than spread wholesale.
const toFilterInput = (filter: Record<string, unknown> = {}) => {
    const {accountId, applicationId, accountApplicationStatus} = filter;
    const input: Record<string, unknown> = {};
    if (accountId) input.accountId = accountId;
    if (applicationId) input.applicationId = applicationId;
    if (accountApplicationStatus) input.accountApplicationStatus = accountApplicationStatus;
    return input;
};

// Returns the WHOLE page — items AND nextToken — not just the items.
// Under token pagination the caller (useInfiniteQuery) needs the cursor to ask
// for the next page; a service that returns `.items` alone makes pagination
// structurally impossible no matter what the query selects. listAccountApplications
// has always selected nextToken (see queries.ts); it was being discarded here.
export const fetchRecords = async (
    {
        filter,
        limit,
        nextToken,
    }: {
        filter?: Record<string, unknown>,
        limit?: number,
        nextToken?: string | null,
    } = {}
) => {
    const response = await client.graphql<GraphQLQuery<ListApplicationAccounts>>({
                                                                                     query: listApplicationAccounts,
                                                                                     variables: {
                                                                                         filter: toFilterInput(filter),
                                                                                         limit: limit,
                                                                                         nextToken: nextToken,
                                                                                     },
                                                                                 });
    return {
        items: response.data?.listAccountApplications.items ?? [],
        nextToken: response.data?.listAccountApplications.nextToken ?? null,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetApplicationAccount>>({
                                                                                   query: getApplicationAccount,
                                                                                   variables: {id: id},
                                                                               });
    return response.data?.getAccountApplication;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateApplicationAccount>>({
                                                                                      query: createApplicationAccount,
                                                                                      variables: {input: payload},
                                                                                  });
    return response.data?.createAccountApplication;
};

export const update = async (_id: string, record: ApplicationAccount) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateApplicationAccount>>({
                                                                                      query: (updateApplicationAccount),
                                                                                      variables: {input: record},
                                                                                  });
    return response.data?.updateAccountApplication;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteApplicationAccount>>({
                                                                                      query: (deleteApplicationAccount),
                                                                                      variables: {input: {id: id}},

                                                                                  });
    return response.data?.deleteAccountApplication;
};
